import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "title-wrapper pa-1 px-3" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "mr-3 text-grey" }
const _hoisted_9 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { style: {"white-space":"pre-wrap"} }
const _hoisted_12 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_13 = { class: "d-flex align-center" }
const _hoisted_14 = { style: {"white-space":"pre-wrap"} }
const _hoisted_15 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_16 = { class: "d-flex align-center" }
const _hoisted_17 = { class: "mr-3 text-grey" }
const _hoisted_18 = { class: "mr-3" }
const _hoisted_19 = { class: "subtitle-wrapper pa-1 px-3" }
const _hoisted_20 = { class: "d-flex align-center" }
const _hoisted_21 = { class: "mr-3 text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        (_ctx.clas)
          ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
              key: 0,
              style: {"position":"absolute"},
              onClick: _ctx.toClassDiary
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  large: "",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        (_ctx.child && _ctx.clas)
          ? (_openBlock(), _createBlock(_component_v_app_bar_title, {
              key: 1,
              style: {"min-width":"fit-content"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((_ctx.child.lastName + ' ' + _ctx.child.firstName).length > 14
            ? (_ctx.child.lastName + ' ' + _ctx.child.firstName).slice(0, 14) + '…' 
            : _ctx.child.lastName + ' ' + _ctx.child.firstName), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat",
          icon: "",
          onClick: _ctx.openSelectChildDialog,
          height: "40",
          width: "40"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "white" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" mdi-arrow-down-drop-circle-outline ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
    }, [
      _createVNode(_component_DatePager, {
        date: _ctx.date,
        onAddDay: _ctx.addDay,
        onSubtractDay: _ctx.subtractDay
      }, null, 8, ["date", "onAddDay", "onSubtractDay"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.parentsRecordTitle')), 1)
      ]),
      (_ctx.fetchLoading)
        ? (_openBlock(), _createBlock(_component_VueLoading, {
            key: 0,
            height: '50vh'
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.sleepTime')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.sleeps, (sleep, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-sleeps`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatTime(sleep.from)) + " 〜 " + _toDisplayString(_ctx.formatTime(sleep.to)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.temperature')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.temperatures, (temperature, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-temperatures`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatTime(temperature.recordedAt)), 1),
                            _createElementVNode("div", null, _toDisplayString(temperature.temperature.toFixed(1)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.breakfast')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.breakfasts, (breakfast, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-breakfasts`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(breakfast.content), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.dinner')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.dinners, (dinner, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-dinners`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("p", _hoisted_14, _toDisplayString(dinner.content), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.milk')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.milks, (milk, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-milks`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatTime(milk.recordedAt)), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.showMilkCategory(milk.milkCategory)), 1),
                            _createElementVNode("div", null, _toDisplayString(milk.amount? milk.amount.value + 'cc': _ctx.$t('records.unknown')), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('records.defecation')), 1)
            ]),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReport.defecations, (defecation, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: `${index}-defecations`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, { class: "pa-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatTime(defecation.recordedAt)), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.showDefecationStatus(defecation.state)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      action: _withCtx(({ attrs }) => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "outline-primary",
          text: ""
        }, attrs, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.snackbar = false))
        }), {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogFlg,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogFlg) = $event)),
      width: "280px",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "selectItemList pb-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedClass,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedClass) = $event)),
                    _ctx.selectChildItems
                  ],
                  items: _ctx.classList,
                  "item-title": "className",
                  "item-value": "classId",
                  variant: "filled",
                  "hide-details": "",
                  "return-object": "",
                  color: "rgb(105,105,105)"
                }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              style: {"height":"40vh"},
              class: "childList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, (c, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        onClick: ($event: any) => (_ctx.toClassChildrenRecords(c))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto",
      "max-width": "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              type: "date",
              "day-format": (date) => new Date(date).getDate(),
              "no-title": "",
              "hide-header": "",
              color: "primary"
            }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}